import { ERoutes } from "./ERoutes";
import { INavigationItem } from "./components";
import { ETLCodes } from "./locales";

export const BaseAppNavigation: INavigationItem[] = [
  {
    name: ETLCodes.Home,
    route: ERoutes.home,
    icon: "home",
  },
  {
    name: ETLCodes.Dashboard,
    alternativeIcon: "fas fa-columns",
    items: [
      {
        name: ETLCodes.UnassignedRequests,
        route: ERoutes.unassignedRequests,
      },
      {
        name: ETLCodes.AssignedRequests,
        route: ERoutes.assignedRequests,
      },
    ],
  },
  {
    name: ETLCodes.Cynology,
    alternativeIcon: "fas fa-dog",
    items: [
      {
        name: ETLCodes.Dogs,
        route: ERoutes.dog,
      },
      {
        name: ETLCodes.Colors,
        route: ERoutes.color,
      },
      {
        name: ETLCodes.BreedGroups,
        route: ERoutes.breedGroups,
      },
      {
        name: ETLCodes.Breeds,
        route: ERoutes.breeds,
      },
    ],
  },
  {
    name: ETLCodes.Divers,
    alternativeIcon: "fas fa-info",
    items: [
      {
        name: ETLCodes.CalendarYears,
        route: ERoutes.calendarYear,
      },

      {
        name: ETLCodes.Countries,
        route: ERoutes.country,
      },
    ],
  },
  {
    name: ETLCodes.Affixes,
    alternativeIcon: "fas fa-paw",
    items: [
      {
        name: ETLCodes.Kennels,
        route: ERoutes.kennel,
      },
      {
        name: ETLCodes.FCIAffixesExport,
        route: `${ERoutes.affixExport}/newKennel`,
      },
      {
        name: ETLCodes.FCIAffixesImport,
        route: `${ERoutes.affixImport}/newKennel`,
      },
    ],
  },
  {
    name: ETLCodes.Health,
    alternativeIcon: "fas fa-book-medical",
    items: [
      {
        name: ETLCodes.Clinics,
        route: ERoutes.clinic,
      },
      {
        name: ETLCodes.Characteristics,
        route: ERoutes.characteristics,
      },
      {
        name: ETLCodes.CharacteristicValues,
        route: ERoutes.characteristicValues,
      },
      {
        name: ETLCodes.Packs,
        route: ERoutes.healthPack,
      },
    ],
  },
  {
    name: ETLCodes.Dysplasias,
    alternativeIcon: "fas fa-bone",
    items: [
      {
        name: ETLCodes.Commissions,
        route: ERoutes.commissionDysplasia,
      },
      {
        name: ETLCodes.GentCommission,
        route: ERoutes.gentCommission,
      },
      {
        name: ETLCodes.Appeals,
        route: ERoutes.appealDysplasia,
      },
    ],
  },
  {
    name: ETLCodes.Sport,
    alternativeIcon: "fas fa-medal",
    items: [
      {
        name: ETLCodes.WorkbookTypes,
        route: ERoutes.workbookType,
      },
      {
        name: ETLCodes.Clubs,
        route: ERoutes.club,
      },
      {
        name: ETLCodes.ClubRoles,
        route: ERoutes.clubRoles,
      },

      {
        name: ETLCodes.TitleTypes,
        route: ERoutes.titleType,
      },
      {
        name: ETLCodes.Sections,
        route: ERoutes.section,
      },
      {
        name: ETLCodes.Activities,
        route: ERoutes.activity,
      },
      {
        name: ETLCodes.SubActivities,
        route: ERoutes.subActivity,
      },
      {
        name: ETLCodes.Competitions,
        route: ERoutes.competition,
      },
    ],
  },
  {
    name: ETLCodes.Requests,
    alternativeIcon: "fas fa-folder",
    items: [
      {
        name: ETLCodes.AllRequests,
        route: ERoutes.requests,
      },
      {
        name: ETLCodes.Dog,
        items: [
          {
            name: ETLCodes.TempRSHRequests,
            route: ERoutes.tempRsh,
          },
          {
            name: ETLCodes.RSH,
            route: ERoutes.rsh,
          },
          {
            name: ETLCodes.BroodRequests,
            route: ERoutes.broodRequest,
          },
          {
            name: ETLCodes.ExpatriationRequest,
            route: ERoutes.expatriationRequest,
          },
        ],
      },
      {
        name: ETLCodes.Divers,
        items: [
          {
            name: ETLCodes.AffixRequests,
            route: ERoutes.affixRequest,
          },
          {
            name: ETLCodes.MembershipRequests,
            route: ERoutes.membershipRequest,
          },
          {
            name: ETLCodes.MiscellaneousRequests,
            route: ERoutes.miscellaneousRequest,
          },
        ],
      },
      {
        name: ETLCodes.Pedigree,
        items: [
          {
            name: ETLCodes.RISHRequests,
            route: ERoutes.rish,
          },
          {
            name: ETLCodes.PedigreeDuplicataRequests,
            route: ERoutes.pedigreeDuplicata,
          },
          {
            name: ETLCodes.ImportRequests,
            route: ERoutes.importRequest,
          },
        ],
      },
      {
        name: ETLCodes.Health,
        items: [
          {
            name: ETLCodes.DysplasiaRequests,
            route: ERoutes.dysplasiaRequest,
          },
          {
            name: ETLCodes.HealthTestRequests,
            route: ERoutes.healthTestRequest,
          },
        ],
      },
      {
        name: ETLCodes.Sport,
        items: [
          {
            name: ETLCodes.WorkAttestationRequests,
            route: ERoutes.workAttestationRequest,
          },
          {
            name: ETLCodes.WorkbookRequests,
            route: ERoutes.workbookRequest,
          },
          {
            name: ETLCodes.CompetitionRequests,
            route: ERoutes.competitionRequest,
          },
          {
            name: ETLCodes.TitleRequests,
            route: ERoutes.titleRequests,
            //disabled: true,
          },
        ],
      },
    ],
  },

  {
    name: ETLCodes.Contacts,
    icon: "people",
    items: [
      {
        name: ETLCodes.People,
        route: ERoutes.people,
      },
    ],
  },
  {
    name: ETLCodes.Administration,
    icon: "cog",
    items: [
      {
        name: ETLCodes.Articles,
        route: ERoutes.article,
      },
      {
        name: ETLCodes.Users,
        route: ERoutes.user,
      },
      {
        name: ETLCodes.MembershipRenewals,
        route: ERoutes.membershipRenewal,
      },
      {
        name: ETLCodes.Languages,
        route: ERoutes.language,
      },
      {
        name: ETLCodes.Emails,
        route: ERoutes.email,
      },
      {
        name: ETLCodes.RePrint,
        route: ERoutes.reprintPedigree,
      },
      {
        name: ETLCodes.Reports,
        route: ERoutes.report,
      },
    ],
  },
];

const InnerFindAppNavigationItemFromRoute = (pathname: string, navItem: INavigationItem) => {
  if (navItem && navItem.route && pathname.startsWith(navItem.route)) {
    return navItem;
  }
  const nextNavItems = navItem.items;
  if (nextNavItems && nextNavItems?.length > 0) {
    for (let i of nextNavItems) {
      const found = InnerFindAppNavigationItemFromRoute(pathname, i);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const FindAppNavigationItemFromRoute = (pathname: string) => {
  for (let i of BaseAppNavigation) {
    const found = InnerFindAppNavigationItemFromRoute(pathname, i);
    if (found) return found;
  }
  return null;
};

export const AppNavigation = (modules: string[]) => {
  const filtered: INavigationItem[] = [];
  BaseAppNavigation.forEach((n) => {
    const filteredItem = FilterNavItemRoutes(n, modules);
    if (!filteredItem?.items || filteredItem?.items.length > 0) {
      filtered.push(filteredItem);
    }
  });
  return filtered;
};

const FilterNavItemRoutes = (item: INavigationItem, modules: string[]): INavigationItem => {
  let filtered: INavigationItem = { ...item };
  if (item.items) {
    filtered.items = [];
    item.items.forEach((n) => {
      const filteredItem = FilterNavItemRoutes(n, modules);
      if (filteredItem && (!filteredItem.items || filteredItem.items.length > 0)) {
        filtered.items.push(filteredItem);
      }
    });
  }
  if (filtered.route) {
    filtered = modules.includes(filtered.route.split("/")[1].toUpperCase()) ? filtered : null;
  }
  return filtered;
};
